export default __webpack_public_path__ + "static/media/error-emoji.eac33482.gif";